export const collectionProductEventsConfig = {
    parentSelector: '.template-collection',
    events: {
        // Filter accordion events
        filterAccordion: {
            parentSelector: '.facets__disclosure',
            selector: '.facets__summary',
            events: {
                open: {
                    event: 'collections',
                    component: 'filter',
                    element: 'accordion',
                    action: 'open',
                    trigger: 'focus',
                    getDynamicData: (element) => {
                        const label = element.querySelector('.facets__summary-label');
                        // Handle price accordion specifically if it lacks the label span
                        const fieldName = label ? label.textContent.trim() : (element.textContent.includes('Price') ? 'price' : 'unknown'); 
                        return {
                            field: fieldName
                        };
                    }
                },
                close: {
                    event: 'collections',
                    component: 'filter',
                    element: 'accordion',
                    action: 'close',
                    trigger: 'click',
                    getDynamicData: (element) => {
                        const label = element.querySelector('.facets__summary-label');
                        // Handle price accordion specifically if it lacks the label span
                        const fieldName = label ? label.textContent.trim() : (element.textContent.includes('Price') ? 'price' : 'unknown'); 
                        return {
                            field: fieldName
                        };
                    }
                }
            }
        },

        // Filter checkbox events
        filterCheckbox: {
            parentSelector: '.facets__disclosure',
            selector: '.facets__label input[type="checkbox"]',
            event: { 
                event: 'collections',
                component: 'filter',
                element: 'checkbox',
                trigger: 'change',
                getDynamicData: (element) => {
                    const isChecked = element.checked;
                    const action = isChecked ? 'on' : 'off'; 

                    const disclosure = element.closest('.facets__disclosure');
                    const summaryElement = disclosure?.querySelector('.facets__summary'); 
                    const summaryLabel = summaryElement?.querySelector('.facets__summary-label');
                    const fieldName = summaryLabel 
                        ? summaryLabel.textContent.trim() 
                        : (summaryElement?.textContent.includes('Price') ? 'price' : 'unknown');

                    const checkboxLabelElement = element.closest('.facets__label')?.querySelector('.facet-checkbox__text-label');
                    const checkboxValue = checkboxLabelElement ? checkboxLabelElement.textContent.trim() : element.value; 

                    return {
                         action: action,
                         field: fieldName, 
                         action_value: checkboxValue
                    };
                }
            }
        },

        // Filter price input events
        filterPrice: {
            parentSelector: '.facets__price',
            selector: '.field__input',
            events: {
                focus: {
                    event: 'collections',
                    component: 'filter',
                    element: 'text_field',
                    field: 'price',
                    action: 'focus',
                    trigger: 'focus'
                },
                input: {
                    event: 'collections',
                    component: 'filter',
                    element: 'text_field',
                    field: 'price',
                    action: 'input',
                    trigger: 'input',
                    getDynamicData: (element) => ({
                        action_value: element.value
                    })
                }
            }
        },

        // Filter reset events
        filterReset: {
            parentSelector: '.facets__disclosure .facets__header, #FacetsWrapperMobile .mobile-facets__footer', 
            selector: '.facets__reset, .mobile-facets__clear', 
            event: {
                event: 'collections',
                component: 'filter',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    action_value: element.textContent.trim()
                 })
            }
        },

        // Sorting dropdown events
        sorting: {
            parentSelector: '.facet-filters.sorting, .mobile-facets__sort',
            selector: '#SortBy, #SortBy-mobile',
            events: {
                 open: {
                     event: 'collections', 
                     component: 'sorting',
                     element: 'dropdown',
                     action: 'open', 
                     trigger: 'focus',
                 },
                select: {
                    event: 'collections',
                    component: 'sorting',
                    element: 'dropdown',
                    action: 'select',
                    trigger: 'change',
                    getDynamicData: (element) => {
                        return {
                            action_value: element.options[element.selectedIndex].text.trim()
                        };
                    }
                }
            }
        },

        // Product card click event
        productCardClick: {
            parentSelector: '#product-grid', 
            selector: '.card-wrapper a.full-unstyled-link',
            event: {
                event: 'collections',
                component: 'product_card',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                     const cardWrapper = element.closest('.card-wrapper');
                     const headingElement = cardWrapper?.querySelector('.card__heading a');
                     const productName = headingElement ? headingElement.textContent.trim() : 'unknown product';
                     return {
                         field: productName,
                         link_url: element.href
                    };
                }
            }
        },

        // Product card CTA button click event
        productCardCTA: {
            parentSelector: '#product-grid',
            selector: 'button.quick-add__submit',
            event: {
                event: 'collections',
                component: 'product_card',
                element: 'cta_button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const cardWrapper = element.closest('.card-wrapper');
                    const headingElement = cardWrapper?.querySelector('.card__heading a');
                    const productName = headingElement ? headingElement.textContent.trim() : 'unknown product';
                    const clickText = element.querySelector('span')?.textContent.trim() || 'Add to cart';
                    const form = element.closest('form');
                    const linkUrl = form ? form.action : '/cart';
                    return {
                        field: productName,
                        action_value: clickText,
                        link_url: linkUrl 
                    };
                }
            }
        },

        // Pagination events
        pagination: {
            parentSelector: '.pagination-wrapper',
            selector: '.pagination__item.link',
            events: { 
                next: {
                     selector: 'a.pagination__item-arrow[aria-label*="Next"]',
                     event: 'collections',
                     component: 'pagination',
                     element: 'chevron',
                     action: 'click',
                     trigger: 'click',
                     action_value: 'next'
                 },
                previous: {
                    selector: 'a.pagination__item-arrow[aria-label*="Previous"]',
                     event: 'collections',
                     component: 'pagination',
                     element: 'chevron',
                     action: 'click',
                     trigger: 'click',
                     action_value: 'previous'
                },
                number: {
                     selector: 'a.pagination__item.link:not(.pagination__item-arrow)',
                     event: 'collections',
                     component: 'pagination',
                     element: 'number',
                     action: 'click',
                     trigger: 'click',
                     getDynamicData: (element) => ({
                         action_value: element.textContent.trim()
                     })
                 }
            }
        },

        // Filter remove events
        filterRemove: {
             parentSelector: '.active-facets', 
             selector: '.active-facets__button span.active-facets__button-inner',
             event: {
                 event: 'collections',
                 component: 'filter',
                 element: 'filter',
                 action: 'click',
                 trigger: 'click',
                 getDynamicData: (element) => {
                    const clonedElement = element.cloneNode(true);
                    const svgElement = clonedElement.querySelector('svg');
                    const hiddenSpan = clonedElement.querySelector('.visually-hidden');
                    if (svgElement) svgElement.remove();
                    if (hiddenSpan) hiddenSpan.remove();

                    return {
                         action_value: 'remove',
                         filter_name: clonedElement.textContent.trim()
                     };
                 }
             }
         },
         
         // Filter remove all event
         filterRemoveAll: {
             parentSelector: '.active-facets, .mobile-facets__footer',
             selector: '.active-facets__button-remove span, .mobile-facets__clear',
             event: {
                 event: 'collections',
                 component: 'filter', 
                 element: 'link',
                 action: 'click',
                 trigger: 'click',
                 getDynamicData: (element) => ({
                     action_value: 'remove all',
                     click_text: element.textContent.trim() 
                 })
             }
         }
    }
};